import React from 'react';
import PropTypes from 'prop-types';
import { transparentize } from 'polished';
import { AlertStyled } from './styles';
import {
  SvgSlash,
  SvgTriangle,
  SvgWrapper,
  SvgThumbsUp,
  SvgUser,
  SvgWallet,
  SvgTrend,
  SvgClock,
} from '../../svg';
import { useTheme } from '../../theme';

const Alert = React.forwardRef((props, ref) => {
  const { noMargin, type, icon, color, label, scrollTo, children, style, ...rest } = props;
  const theme = useTheme();

  const typesMap = {
    danger: {
      icon: 'slash',
      color: theme.colors.danger90w,
    },
    warning: {
      icon: 'triangle',
      color: theme.colors.warning90w,
    },
    info: {
      icon: 'user',
      color: transparentize(0.85, theme.colors.chart8),
    },
    success: {
      icon: 'thumbUp',
      color: theme.colors.success90w,
    },
  };

  const selectedColor = color || typesMap[type].color;
  const selectedIcon = icon || typesMap[type].icon;

  const iconsMap = {
    slash: <SvgSlash />,
    triangle: <SvgTriangle />,
    user: <SvgUser />,
    thumbUp: <SvgThumbsUp />,
    wallet: <SvgWallet />,
    trend: <SvgTrend />,
    clock: <SvgClock />,
  };

  const internalRef = React.useRef();
  React.useEffect(() => {
    const refToUse = ref ?? internalRef;
    if (refToUse?.current && scrollTo) {
      // to let react position its stuff
      setTimeout(() => {
        refToUse.current.scrollIntoView(true);
      }, 0);
    }
  }, [ref, scrollTo]);

  return (
    <AlertStyled
      ref={ref ?? internalRef}
      role="alert"
      color={selectedColor}
      noMargin={noMargin}
      style={style}
      {...rest}
    >
      <SvgWrapper style={{ marginRight: 15 }}>{iconsMap[selectedIcon]}</SvgWrapper>
      {label || children}
    </AlertStyled>
  );
});

Alert.propTypes = {
  noMargin: PropTypes.bool,
  scrollTo: PropTypes.bool,
  label: PropTypes.string,
  icon: PropTypes.oneOf([
    'slash',
    'triangle',
    'user',
    'thumbUp',
    'wallet',
    'portfolio',
    'clock',
    'trend',
  ]),
  color: PropTypes.string,
  style: PropTypes.object,
  children: PropTypes.node,
  type: PropTypes.oneOf(['danger', 'warning', 'info', 'success']),
};

Alert.defaultProps = {
  type: 'info',
};

export default Alert;
